import { useState } from 'react';
import { Alert, Button, TextField, Typography } from '@mui/material';

import { Modal } from '../Modal.jsx';

import { ID_RE } from './constants';

export function CreateSubWorkflowModal({
  onCancel,
  onCreated,
}: {
  onCancel: () => void;
  onCreated: (childId: string) => void;
}) {
  const [id, setId] = useState('');
  const [title, setTitle] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const trimmed = id.trim();
  const idError =
    trimmed && !ID_RE.test(trimmed)
      ? 'Use letters, numbers and underscores only.'
      : null;
  const canCreate = Boolean(trimmed) && !idError && !busy;

  const create = () => {
    if (!canCreate) {
      return;
    }
    setBusy(true);
    setError(null);
    try {
      // await adminApi.createWorkflow({
      //   workflowId: trimmed,
      //   title: title.trim() || trimmed,
      // });
      onCreated(trimmed);
    } catch (error_) {
      setError(String(error_));
      setBusy(false);
    }
  };

  return (
    <Modal
      title="New sub-workflow"
      onClose={onCancel}
      actions={
        <>
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="contained" disabled={!canCreate} onClick={create}>
            {busy ? 'Creating…' : 'Create & link'}
          </Button>
        </>
      }
    >
      <TextField
        label="Sub-workflow id"
        autoFocus
        placeholder="e.g. vessel_lookup"
        value={id}
        onChange={(e) => setId(e.target.value)}
        error={Boolean(idError)}
        helperText={idError ?? ' '}
      />
      <TextField
        label="Title"
        placeholder={trimmed || 'Title'}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      {error && <Alert severity="error">{error}</Alert>}
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        It will be linked to this step. Save this draft, then use “Manage →” to
        design it.
      </Typography>
    </Modal>
  );
}
